import { IconButton } from "../IconButton/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import { useDispatch } from "react-redux";
import * as AppActionCreators from "src/redux/actions/App.Actions";

import { Box, Link, SnackbarContent, Typography, useTheme } from "@mui/material";

interface ISnackbarProps {
  className?: string;
  variant: "success" | "warning" | "error" | "info";
  message: any;
  action?: JSX.Element;
  actionURL?: string | null;
  actionType?: "external-link" | null;
  actionLabel?: string | null;
}

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

export const CustomSnackbar = (props: ISnackbarProps): JSX.Element => {
  const { message, variant, actionURL, actionType, actionLabel } = props;
  const theme = useTheme();
  const dispatch = useDispatch();
  const Icon = variantIcon[variant];

  const handleCloseSnackbar = (): void => {
    dispatch(AppActionCreators.closeSnackbar());
  };

  const snackStyles = {
    success: {
      backgroundColor: theme.palette.success.dark,
      color: theme.palette.common.white,
    },
    error: {
      backgroundColor: theme.palette.error.dark,
      color: theme.palette.common.white,
    },
    info: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
    },
    warning: {
      backgroundColor: "#ff8800",
      color: theme.palette.common.white,
    },
  };
  const actions =
    actionURL && actionType && actionLabel
      ? [
          <Typography key="action">
            <Link href={actionURL} target="_blank" sx={{ fontWeight: 700, color: theme.palette.common.white, mr: 1 }}>
              {actionLabel}
            </Link>
          </Typography>,
          <IconButton
            id="close_snackbar_btn"
            key="close"
            aria-label="Close"
            color="inherit"
            className="close"
            onClick={handleCloseSnackbar}
            size="large"
            sx={{ width: "20px" }}
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>,
        ]
      : [
          <IconButton
            id="close_snackbar_btn"
            key="close"
            aria-label="Close"
            color="inherit"
            className="close"
            onClick={handleCloseSnackbar}
            size="large"
            sx={{ width: "20px" }}
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>,
        ];

  return (
    <SnackbarContent
      aria-describedby="client-snackbar"
      sx={snackStyles[variant]}
      message={
        <Box
          id="client-snackbar"
          sx={{
            display: "flex",
            alignItems: "space-between",
          }}
        >
          <Icon sx={{ fontSize: 20, opacity: 0.9, mr: 1 }} />
          {message}
        </Box>
      }
      action={actions}
    />
  );
};
